export default __webpack_public_path__ + "static/media/Logo_Final_Blac.9fb7c912.png";